import type uPlot from 'uplot';

const zoomFactor = 0.9;

/**
 * 마우스 휠 줌 플러그인 — x축 기준 줌 인/아웃
 */
export const wheelZoomPlugin = (): uPlot.Plugin => {
  let wheelHandler: ((event: WheelEvent) => void) | null = null;

  return {
    hooks: {
      ready: [
        (chart) => {
          wheelHandler = (event: WheelEvent): void => {
            event.preventDefault();

            const left = chart.cursor.left ?? 0;
            const xScale = chart.scales.x;

            if (xScale.min == null || xScale.max == null) {
              return;
            }

            const zoomDirection = event.deltaY < 0 ? zoomFactor : 1 / zoomFactor;
            const range = xScale.max - xScale.min;
            const centerValue = chart.posToVal(left, 'x', true);

            const nextMin = centerValue - (centerValue - xScale.min) * zoomDirection;
            const nextMax = centerValue + (xScale.max - centerValue) * zoomDirection;

            if (!Number.isFinite(nextMin) || !Number.isFinite(nextMax) || nextMax <= nextMin) {
              return;
            }

            const minRange = range / 10;
            const nextRange = nextMax - nextMin;
            if (nextRange < minRange) {
              return;
            }

            chart.setScale('x', { min: nextMin, max: nextMax });
          };

          chart.over.addEventListener('wheel', wheelHandler, { passive: false });
        },
      ],
      destroy: [
        (chart) => {
          if (!wheelHandler) {
            return;
          }

          chart.over.removeEventListener('wheel', wheelHandler);
          wheelHandler = null;
        },
      ],
    },
  };
};
